<script lang="ts">
export default {
  name: "AppNavigationFleetsNav",
};
</script>

<script lang="ts" setup>
import NavItem from "@/shared/components/AppNavigation/NavItem/index.vue";
import { useFleetStore } from "@/frontend/stores/fleet";
import { storeToRefs } from "pinia";
import { useSessionStore } from "@/frontend/stores/session";
import { useI18n } from "@/shared/composables/useI18n";
import {
  useMyFleets as useMyFleetsQuery,
  useFleetInvites as useFleetInvitesQuery,
} from "@/services/fyApi";

const { t } = useI18n();

const fleetStore = useFleetStore();

const { preview: fleetPreview } = storeToRefs(fleetStore);

const sessionStore = useSessionStore();

const { isAuthenticated } = storeToRefs(sessionStore);

const route = useRoute();

const active = computed(() => {
  return ["fleets", "fleet-add", "fleet-preview", "fleet-invites"].includes(
    String(route.name),
  );
});

const { data: fleets, refetch: refetchMyFleets } = useMyFleetsQuery({
  query: {
    refetchOnWindowFocus: false,
    enabled: isAuthenticated.value,
  },
});

const { data: fleetInvites, refetch: refetchInvites } = useFleetInvitesQuery({
  query: {
    enabled: isAuthenticated.value && active.value,
  },
});

watch(
  () => isAuthenticated.value,
  async () => {
    if (isAuthenticated.value) {
      await refetchMyFleets();
      await refetchInvites();
    }
  },
);
</script>

<template>
  <NavItem
    :label="t('nav.fleets.index')"
    :submenu-active="active"
    menu-key="fleets-menu"
    icon="fa-duotone fa-users"
  >
    <template #submenu>
      <NavItem
        v-for="fleet in fleets"
        :key="fleet.slug"
        :menu-key="fleet.slug"
        :to="{ name: 'fleet', params: { slug: fleet.slug } }"
        :label="fleet.name"
        :image="fleet.logo?.smallUrl || undefined"
      />
      <NavItem
        v-if="isAuthenticated && fleetInvites && fleetInvites.length"
        :to="{ name: 'fleet-invites' }"
        :label="t('nav.fleets.invites')"
        icon="fa-duotone fa-envelope-open-text"
      />
      <NavItem
        v-if="isAuthenticated || !fleetPreview"
        :to="{ name: 'fleet-add' }"
        :label="t('nav.fleets.add')"
        icon="fa-light fa-plus"
      />
      <NavItem
        v-else
        :to="{ name: 'fleet-preview' }"
        :label="t('nav.fleets.add')"
        icon="fa-light fa-plus"
      />
    </template>
  </NavItem>
</template>

<style lang="scss" scoped>
@import "index";
</style>
